import React from 'react';
import { useTranslation } from 'react-i18next';

import Checkbox from 'component/Layout/Form/Checkbox';

import classNames from 'classnames';

import { useRebookable } from 'hooks/form/filter';
import { useSpecialMeta } from 'hooks/form/meta';
import { useChangedFilterList } from 'hooks/form/useChangedFilterList';
import { QaIdentifier } from 'hooks/useQa';

import { SearchParam } from 'types/Search/params';

import styles from '../Filter.module.scss';
import Segment from '../Segment';
import {
    MetaValue,
    useDisabledStatus,
} from '../Segment/__hooks/useDisabledStatus';
import FilterLabel from '../Segment/FilterLabel';

const Rebook = ({ disableWhen = MetaValue.NoResult }) => {
    const { t } = useTranslation();
    const [rebookable, setRebookable] = useRebookable();
    const [specialMeta] = useSpecialMeta();
    const { onToggle, onClear, isFilterChanged } = useChangedFilterList();
    const getDisabledStatus = useDisabledStatus(disableWhen);
    // if (!specialMeta?.rebookable?.hasCount && !rebookable) {
    //     return null;
    // }
    return (
        <Segment
            withDeleteLink
            onDelete={() => {
                rebookable && onClear(() => [SearchParam.Rebookable]);
                setRebookable(false);
            }}
            headline={{ text: t('TRANS-rebooking') }}
            qaIdentifier={QaIdentifier.Search_Filter_Section_Rebooking}
            filterList={[
                {
                    isSelected: rebookable,
                    filterValue: t('TRANS-rebookable-at-no-cost'),
                    content: (
                        <Checkbox
                            key={SearchParam.Rebookable}
                            input={{
                                id: SearchParam.Rebookable,
                            }}
                            isChecked={rebookable}
                            isOnlyDeselectable={
                                rebookable &&
                                specialMeta?.rebookable?.hasCount &&
                                specialMeta.rebookable.count === 0
                            }
                            onChange={() => {
                                onToggle(SearchParam.Rebookable);
                                setRebookable((current) => !current);
                            }}
                            isDisabled={
                                // specialMeta?.rebookable?.hasCount &&
                                // specialMeta?.rebookable?.count === 0
                                specialMeta?.rebookable
                                    ? !rebookable &&
                                      getDisabledStatus(specialMeta?.rebookable)
                                    : true
                            }
                            withUXSelection
                            customClass={{
                                Wrapper: classNames({
                                    [styles.Changed]: isFilterChanged(
                                        SearchParam.Rebookable
                                    ),
                                }),
                            }}
                        >
                            <FilterLabel
                                labelText={t('TRANS-rebookable-at-no-cost')}
                                tooltip={`<b>${t(
                                    'TRANS-rebookable-at-no-cost'
                                )}</b><p>${t(
                                    'TRANS-show-free-rebookable-offers'
                                )}</p>`}
                                {...specialMeta?.rebookable}
                            />
                        </Checkbox>
                    ),
                },
            ]}
        />
    );
};

export default Rebook;
